import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './follow-media-icons.component.scss';
var FollowMediaIcons = /** @class */ (function (_super) {
    tslib_1.__extends(FollowMediaIcons, _super);
    function FollowMediaIcons(element) {
        return _super.call(this, element) || this;
    }
    FollowMediaIcons.prototype.init = function () {
    };
    FollowMediaIcons.prototype.bindEvents = function () {
    };
    return FollowMediaIcons;
}(Base));
export { FollowMediaIcons };



//////////////////
// WEBPACK FOOTER
// ./components/follow-media-icons/follow-media-icons.component.ts
// module id = 292
// module chunks = 0